module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIUlEQVQ4T2NgGBwgdMl/dIwO3juaYuBRA0YNGGwGDGkAAArsnySQeETcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/FR.png
// module id = 1141
// module chunks = 0